<template>
  <div>
    <b-button variant="outline-secondary" v-b-modal.modal-download-remote-csv class="btn btn-sm">
      <i class="fas fa-download pr-1"></i> <span v-text="text"></span>
    </b-button>

    <b-modal id="modal-download-remote-csv" :title="text" hide-footer>

      <div class="row mb-1">
        <label class="col-2">From:</label>
        <div class="col-10">
          <b-form-datepicker
              placeholder="Start Date"
              v-model="dates.start.selected"
              :min="dates.start.min"
              :max="dates.start.max"
          >
          </b-form-datepicker>
        </div>
      </div>

      <div class="row mb-1">
        <label class="col-2">To:</label>
        <div class="col-10">
          <b-form-datepicker
              placeholder="End Date"
              v-model="dates.end.selected"
              :min="dates.end.min"
              :max="dates.end.max"
          >
          </b-form-datepicker>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center mt-3">

        <div class="text-center mr-2" v-if="loading">
          <i class="fas fa-spinner fa-spin"></i>
        </div>

        <b-button class="btn btn-sm" @click="downloadCSV()" :disabled="loading">
          <i class="fas fa-download pr-1"></i> <span>Download CSV</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DownloadRemoteCSVButton',
  props: {
    text: {
      type: String,
      default: 'Download CSV',
    }
  },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    const date = new Date();
    const month = new Date().getMonth();
    const startDate = new Date(date.setMonth(month - 1)).toISOString().slice(0, 10);

    return {
      loading: false,
      dates: {
        end: {
          min: null,
          max: today,
          selected: today,
        },
        start: {
          min: null,
          max: today,
          selected: startDate,
        }
      }
    }
  },

  computed: {
    profile() {
      return this.$store.state.profile;
    }
  },

  methods: {
    downloadCSV() {
      const params = {
        start_date: this.dates.start.selected,
        end_date: this.dates.end.selected,
        token: this.$store.state.session_id
      }

      this.loading = true
      axios({
        url: `${this.$store.state.api_url}focusLogsCSV`,
        params,
      })
          .then((response) => {
            const options = {type: "text/csv;charset=utf-8"}
            const url = window.URL.createObjectURL(
                new Blob([response.data], options)
            )
            const link = document.createElement('a')
            link.href = url
            const filename = `focus-logs${this.dates.start.selected}-TO-${this.dates.end.selected}.csv`
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>
